// import React, { useState, useCallback, useMemo } from "react";
import { Node } from "@tiptap/core";
// import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
// import { useSelector } from "react-redux";
// import LightIcon from "@mui/icons-material/Light";
// import FpRenderText from "../common/FpRenderText";

// const ShowWork = React.memo(({ node }) => {
//   const fpAppV4Data = useSelector((state) => state.fpAppV4Data);
//   const [showWork, setShowWork] = useState(false);

//   const queryAnswer = useMemo(
//     () => fpAppV4Data.queryAnswers.find((qa) => qa.qid === node.attrs.qid),
//     [fpAppV4Data.queryAnswers, node.attrs.qid]
//   );

//   const toolResponse = queryAnswer?.toolResponse;

//   const handleClick = useCallback(
//     (event) => {
//       if (window.hj && !showWork) {
//         window.hj("event", "specific_button_click", {
//           buttonId: "showWorkFpAppV4",
//         });
//       }
//       setShowWork((prev) => !prev);
//     },
//     [showWork]
//   );

//   const renderSectionResponses = useMemo(() => {
//     return toolResponse?.answer?.sectionResponses?.map(
//       (sectionResponse, index) => (
//         <div className="bg-white p-4 mb-4 rounded-md shadow-md" key={index}>
//           <div className="text-[16px]">{sectionResponse?.sectionTitle}</div>
//           <hr />
//           <div className="mt-2">
//             <FpRenderText
//               text={sectionResponse?.response}
//               sourceMap={toolResponse?.answer?.sourceMap}
//               level={2}
//               qid={node.attrs.qid}
//             />
//           </div>
//         </div>
//       )
//     );
//   }, [toolResponse?.answer?.sectionResponses, toolResponse?.answer?.sourceMap]);

//   return (
//     <NodeViewWrapper>
//       <div
//         className="text-[12px] w-fit p-2 bg-gray-100 hover:bg-gray-600 hover:text-white transition-all rounded-md cursor-pointer"
//         onClick={handleClick}
//       >
//         <LightIcon
//           style={{
//             fontSize: "16px",
//           }}
//         />
//         <span className="ml-2">{showWork ? "Hide" : "Show"} Work</span>
//       </div>
//       {showWork && (
//         <div className="p-4 bg-gray-200 mt-6 rounded-md ">
//           {renderSectionResponses}
//         </div>
//       )}
//     </NodeViewWrapper>
//   );
// });

const ShowWorkNode = Node.create({
  name: "showWork",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      qid: {
        default: "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "show-work",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["show-work", HTMLAttributes];
  },

  // addNodeView() {
  //   return ReactNodeViewRenderer(ShowWork);
  // },

  addNodeView() {
    return ({ node }) => {
      const { qid } = node.attrs;
      const dom = document.createElement("div");

      dom.className =
        "show-work rounded-md p-1 px-2 text-[12px] text-white bg-gray-800 border border-gray-300 hover:bg-gray-700 hover:text-white transition-all cursor-pointer w-fit";

      dom.innerHTML = `<span className="">Show Work</span>`;
      dom.onclick = (e) => {
        window.openShowWorkPopover(e, {
          qid,
        });
      };

      return {
        dom,
      };
    };
  },

  addInputRules() {
    return [
      {
        find: /\\showWork$/,
        // Documents are plain text (#11548 round 16): same gate as the
        // \queryInput rule — no invisible node insertion in plain mode.
        replace: () =>
          this.editor.storage.fpPlainDocument
            ? undefined
            : this.editor.commands.insertContent("<show-work></show-work>"),
      },
    ];
  },
});

export default ShowWorkNode;
